var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 15.9237V18.32C20.0004 18.5425 19.9548 18.7627 19.8657 18.9665C19.7766 19.1704 19.6459 19.3533 19.482 19.5037C19.318 19.6541 19.1245 19.7686 18.9138 19.8399C18.703 19.9112 18.4797 19.9376 18.2582 19.9176C15.8002 19.6505 13.4391 18.8106 11.3647 17.4653C9.43467 16.2389 7.79837 14.6026 6.57197 12.6726C5.22201 10.5888 4.3819 8.21623 4.1197 5.74719C4.09974 5.5263 4.12599 5.30368 4.19679 5.09349C4.26758 4.8833 4.38136 4.69015 4.53089 4.52635C4.68042 4.36254 4.86242 4.23167 5.0653 4.14206C5.26818 4.05244 5.48749 4.00605 5.70928 4.00585H8.10563C8.49328 4.00203 8.8691 4.1393 9.16303 4.39208C9.45696 4.64486 9.64894 4.99589 9.7032 5.37975C9.80434 6.14664 9.99192 6.89962 10.2623 7.62433C10.3698 7.91024 10.3931 8.22095 10.3294 8.51967C10.2657 8.81839 10.1177 9.09258 9.90289 9.30976L8.88844 10.3242C10.0255 12.324 11.6813 13.9798 13.6811 15.1169L14.6956 14.1025C14.9128 13.8877 15.187 13.7397 15.4857 13.676C15.7844 13.6123 16.0951 13.6355 16.381 13.743C17.1057 14.0134 17.8587 14.201 18.6256 14.3022C19.0136 14.3569 19.368 14.5523 19.6213 14.8513C19.8746 15.1503 20.0092 15.5319 19.9995 15.9237Z",
    stroke: "white",
    strokeWidth: 1.59757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon2);
export default __webpack_public_path__ + "static/media/support-icon2.dcad27a1557124f5657e9735b947e2ff.svg";
export { ForwardRef as ReactComponent };